import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaterGlassFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 125,
	height: 125,
	viewBox: "0 0 125 125",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M79.168 114.583H45.8346C43.2514 114.598 40.7551 113.652 38.8302 111.929C36.9053 110.206 35.6892 107.829 35.418 105.26L26.043 15.625H98.9596L89.5326 105.26C89.2623 107.82 88.0536 110.19 86.1397 111.911C84.2258 113.633 81.7422 114.585 79.168 114.583Z",
			fill: "#357DED",
			stroke: "#357DED",
			strokeWidth: 3.24675,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5 61.5L25.5 27.5L24 15.5L25.5 14H36.5H69H99L100.5 15.5L100 21.5L97 49L95.5 63L94 62H93L91.5 63L89.5 64L87 65L86 65.5L84.5 66L83 66.5H81H74L70.5 65.5L61.5 61.5L55 58.5L48.5 57L42.5 58L36.5 59L32.5 61L30 63L29.5 61.5Z",
			fill: "#E7E9F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 62V62.5L30 61.5L29 62Z",
			fill: "#E7E9F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 61.5V62L30 61L29 61.5Z",
			fill: "#E7E9F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0387 63.4678C30.0145 63.4879 30.0019 63.5188 30.005 63.5501L30.2391 65.8907L32 83.5L34 105.5L37 108.5L41.2579 112.758L44.5 116H79H80.5L91 105.5L95.289 64.5159C95.4018 63.4382 94.5567 62.5 93.4731 62.5C93.1628 62.5 92.8577 62.5791 92.5864 62.7298L89.0761 64.6799C88.6937 64.8924 88.285 65.0537 87.8606 65.1599L83.0971 66.3507C82.7005 66.4499 82.2933 66.5 81.8845 66.5H74.2338C73.7472 66.5 73.2632 66.429 72.7971 66.2891L68.856 65.1068C68.619 65.0357 68.3876 64.9471 68.1637 64.8418L60 61L52.7777 57.6013C51.9422 57.2081 51.0142 57.054 50.0965 57.1559L38.8863 58.4015C38.3001 58.4667 37.73 58.635 37.2024 58.8988L33.519 60.7405C33.1742 60.9129 32.8504 61.1247 32.5542 61.3715L30.1765 63.3529L30.0387 63.4678Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 83.5L34 105.5L37 108.5L41.2579 112.758L44.5 116H79H80.5L91 105.5L95.289 64.5159C95.4018 63.4382 94.5567 62.5 93.4731 62.5C93.1628 62.5 92.8577 62.5791 92.5864 62.7298L89.0761 64.6799C88.6937 64.8924 88.285 65.0537 87.8606 65.1599L83.0971 66.3507C82.7005 66.4499 82.2933 66.5 81.8845 66.5H74.2338C73.7472 66.5 73.2632 66.429 72.7971 66.2891L68.856 65.1068C68.619 65.0357 68.3876 64.9471 68.1637 64.8418L60 61L52.7777 57.6013C51.9422 57.2081 51.0142 57.054 50.0965 57.1559L38.8863 58.4015C38.3001 58.4667 37.73 58.635 37.2024 58.8988L33.519 60.7405C33.1742 60.9129 32.8504 61.1247 32.5542 61.3715L30.1765 63.3529L30.0387 63.4678L30.2391 65.8907L32 83.5Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.971 114.103C39.3221 114.367 39.7064 114.583 40.114 114.746L41.5738 115.33C41.8573 115.443 42.1507 115.53 42.4501 115.59L44.5 116L41.2579 112.758L37 108.5L34 105.5L34.3439 107.564C34.4471 108.182 34.6657 108.776 34.9884 109.314L36 111L37.0714 112.429C37.3557 112.808 37.6924 113.144 38.0714 113.429L38.971 114.103Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91 105.5L80.5 116H81L83.8761 114.767C84.2901 114.59 84.6783 114.357 85.03 114.076L87 112.5L88.7743 110.726C89.2531 110.247 89.6297 109.676 89.8812 109.047L90.5 107.5L91 105.5Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 42C33.8323 38.7544 39.7097 37 45.75 37C51.7903 37 57.6677 38.7544 62.5 42C67.3323 45.2456 73.2097 47 79.25 47C85.2903 47 91.1677 45.2456 96 42",
			stroke: "#357DED",
			strokeWidth: 3.24675,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5 63.5L27.5 44L39 38.5L48.5 37.5L60 41L69.5 46L80 47L91 44L98 39.5L95 69L30.5 72L29.5 63.5Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99 14C99.6975 14 100.071 14.3243 100.27 14.6713C100.5 15.0706 100.5 15.5 100.5 15.5V16.5L100 22L99 21.5V14Z",
			fill: "#E7E9F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.5 15.5V16.5C100.645 15.623 100.638 15.2052 100.27 14.6713C100.5 15.0706 100.5 15.5 100.5 15.5Z",
			fill: "#E7E9F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 14C24.5 14.5 24 15.5 24 15.5L25.5 14Z",
			fill: "#E7E9F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.1048 60.9972L95.7074 59.1327L94.9958 63.1005L93.1048 60.9972Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96 59C95.7184 59.0475 95.6321 59.1758 95.5 59.5L95 62.5L95.5 63L96 59Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.066 41.2857C94.4792 40.7143 98 39 98 39L97.4132 43C97.4132 43 95.6528 41.8571 95.066 41.2857Z",
			fill: "#357DED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4996 41.0002C30.5 40.5002 27.9996 42.5002 27.4996 42.5002C26.9996 42.5002 27.4996 44.5002 27.4996 44.5002H31.4996C31.4996 44.5002 30.4991 41.5002 30.4996 41.0002Z",
			fill: "#357DED"
		})
	]
});
export default SvgWaterGlassFill;
